import { resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, Suspense as _Suspense, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomContainer = _resolveComponent("CustomContainer", true)!

  return (_openBlock(), _createElementBlock("div", _mergeProps(_ctx.comp.attrs, { style: {"overflow":"hidden"} }), [
    (_ctx.comp.component)
      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dycComponent(_ctx.comp.component)), _normalizeProps(_guardReactiveProps(_ctx.comp.props)), null, 16))
          ]),
          _: 1
        }))
      : (_ctx.comp.nodes && _ctx.comp.nodes.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.comp.nodes, (child, cindex) => {
            return (_openBlock(), _createBlock(_component_CustomContainer, {
              comp: child,
              key: cindex
            }, null, 8, ["comp"]))
          }), 128))
        : _createCommentVNode("", true)
  ], 16))
}